module.exports = __webpack_public_path__ + "img/cimb.f5be7a88.svg";